import React from "react";
import { OUR_CONTACTS_ADDRESS, OUR_CONTACTS_DESCRIPTION, OUR_CONTACTS_GMAIL, OUR_CONTACTS_PHONE, OUR_CONTACTS_TG, OUR_CONTACTS_TITLE } from "../Contexts/config";

export const ContactsSection = ({lang}) => {

    return (
        <section id="contacts" class="text-light p-4 text-center text-sm-start">
            <div class="d-lg-flex justify-content-center">
                <div class="col-lg-8 w-auto dark-green-background p-5">
                    <h1 class="text-center">{OUR_CONTACTS_TITLE[lang]}</h1>
                    <p class="lead">{OUR_CONTACTS_DESCRIPTION[lang]}</p>
                    <div class="mt-3 p-5">
                        <p class="lead"><i class="bi bi-whatsapp px-3"></i>{OUR_CONTACTS_TG[lang]}</p>
                        <p class="lead"><i class="bi bi-telephone px-3"></i>{OUR_CONTACTS_PHONE[lang]}</p>
                        <p class="lead"><i class="bi bi-envelope-at px-3"></i>{OUR_CONTACTS_GMAIL[lang]}</p>
                        <p class="lead text-warning"><i class="bi bi-geo-alt px-3"></i>{OUR_CONTACTS_ADDRESS[lang]}</p>
                        <a class="lead text-white text-decoration-none" href={"https://www.instagram.com/themislegal.uz/"}><i class="bi bi-instagram px-3"></i>Instagram</a>
                    </div>
                </div>
            </div>
        </section>
    );
}